import { useEffect, useState } from "react";
import { DataTable } from "../../components";
import { getTournamentDetail } from "../../api/tournaments";
import { useNavigate, useParams } from "react-router-dom";
import { ITournament, ITournamentCategory } from "../../models/ITournament";
import moment from "moment";
import { Plus } from "@mynaui/icons-react";
import { sportTypeToSlug } from "../../utils/methods";
import { Button, Loader, PageHeader } from "../../ui";

const TournamentCategories = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [tournament, setTournament] = useState<ITournament>();
  const [categories, setCategories] = useState<ITournamentCategory[]>([]);
  const [loading, setLoading] = useState(false);
  const [pageNumber] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [sortDirection] = useState<"asc" | "desc">("desc");
  const [sortColumn] = useState("");

  const getTournamentData = async () => {
    setLoading(true);
    try {
      const { data } = await getTournamentDetail(id!);
      setTournament(data);
      setCategories(data.categories);
      setTotalItems(data.categories.length);
      document.title = `${data?.name} - Categories`;
    } catch (err: any) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTournamentData();
  }, []);

  return (
    <div className="tournament-categories-page">
      <PageHeader
        back={{ to: `/dashboard/tournaments/${id}`, label: "Back" }}
        eyebrow={tournament?.name}
        title="Categories"
        subtitle={!loading ? `${categories.length} Categories` : undefined}
        actions={
          !loading ? (
            <Button
              icon={<Plus size={18} />}
              onClick={() =>
                (window.location.href = `/dashboard/tournaments/${id}/add-category?goTo=category&name=${
                  tournament?.name
                }&type=${sportTypeToSlug(tournament?.type)}`)
              }
            >
              Create new category
            </Button>
          ) : undefined
        }
      />

      {loading ? (
        <Loader />
      ) : (
        <DataTable
          id={"categories-table"}
          data={categories}
          editable={false}
          label={"categories"}
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalPages={totalPages}
          totalItems={totalItems}
          onViewItem={(item) => navigate(`/dashboard/tournaments/${id}/${item.id}?goTo=category`)}
          onPageChange={() => {}}
          onSortChange={() => {}}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          columns={[
            { key: "categoryName", label: "Name" },
            {
              key: "format",
              label: "Format",
              render: (_: any, row: ITournamentCategory) => row.format?.replace("-", " + "),
            },
            {
              key: "numOfPlayers",
              label: "Total Registered Players",
            },
            {
              key: "numOfTeams",
              label: "Total Registered Teams",
            },
            {
              key: "numOfPendingTeams",
              label: "# of Pending Teams",
            },
            {
              key: "numOfConfirmedTeams",
              label: "# of Confirmed Teams",
            },
            {
              key: "startDate",
              label: "Start Date",
              render: (_: any, row: ITournamentCategory) => moment(row.startDate).format("DD MMM YYYY"),
            },
            {
              key: "maxPlayers",
              label: "Max Players per Team",
            },
          ]}
        />
      )}
    </div>
  );
};

export default TournamentCategories;
